import React from 'react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  scrollTo?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href = 'https://pay.hotmart.com/J105051244M',
  scrollTo,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
      return;
    }
    trackAddToCart();
    window.open(href, '_blank', 'noopener,noreferrer');
  };
  return <button onClick={handleClick} className={`
        bg-[#B8963E] hover:bg-[#9c7e32] text-white font-bold py-4 px-8 
        rounded-full transition-all duration-300 shadow-[0_8px_20px_rgba(184,150,62,0.3)] 
        hover:shadow-[0_12px_25px_rgba(184,150,62,0.4)] transform hover:-translate-y-1 
        active:translate-y-0 active:shadow-md
        font-['DM_Sans'] tracking-wide text-lg
        ${fullWidth ? 'w-full' : ''} 
        ${className}
      `} data-id="element-167">
      {children}
    </button>;
}